import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'avaliacao-fisica-personal',
    title: 'Avaliação física para personal',
    description: 'Formulário completo de avaliação física para montar o planejamento de treinos individualizado.',
    indicatedFor: 'Personal trainers',
    stepsCount: 2,
    questionsSummary: ['Objetivo de treino', 'Restrições físicas', 'Frequência disponível', 'Nível de condicionamento'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Avaliação física para personal',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Perfil e objetivos',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Continuar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: 'Qual é o seu nome completo?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'choices',
                        label: 'Qual é o seu principal objetivo?',
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: 'Emagrecimento' },
                                { id: 'opt-2', label: 'Ganho de massa muscular' },
                                { id: 'opt-3', label: 'Condicionamento físico' },
                                { id: 'opt-4', label: 'Saúde e qualidade de vida' },
                                { id: 'opt-5', label: 'Reabilitação / lesão' },
                            ],
                        },
                    },
                    {
                        order: 3,
                        type: 'choices',
                        label: 'Quantos dias por semana você pode treinar?',
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: '2 dias' },
                                { id: 'opt-2', label: '3 dias' },
                                { id: 'opt-3', label: '4 dias' },
                                { id: 'opt-4', label: '5 dias ou mais' },
                            ],
                        },
                    },
                ],
            },
            {
                order: 2,
                title: 'Histórico físico',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'scale',
                        label: 'Como você avalia seu condicionamento físico atual?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Sedentário',
                            maxLabel: 'Muito ativo',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'yes_no_maybe',
                        label: 'Você possui alguma lesão ou limitação física?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'weight',
                        label: 'Qual é o seu peso atual?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
};
